import type { OwaDate } from 'owa-datetime';
import type { ReadWriteRecipientViewState } from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import type { SearchScope } from 'owa-search-service';

export default interface AdvancedSearchViewState {
    selectedSearchScope: SearchScope; // Current value of the selected folder dropdown
    subjectFieldText: string; // Current value of the subject field
    keywordsFieldText: string; // Current value of the keywords field
    fromDate: OwaDate; // Current value of the "From" date field
    toDate: OwaDate; // Current value of the "To" date field
    hasAttachments: boolean; // Current value of the "Has attachments" checkbox
    fromPeopleSuggestions: ReadWriteRecipientViewState[]; // Current value of "From" people picker.
    toPeopleSuggestions: ReadWriteRecipientViewState[]; // Current value of "To" people picker.
    ccPeopleSuggestions: ReadWriteRecipientViewState[]; // Current value of "CC" people picker.
}

export function getDefaultAdvancedSearchViewState(): AdvancedSearchViewState {
    return {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (22,9): Type 'null' is not assignable to type 'SearchScope'.
        // @ts-expect-error
        selectedSearchScope: null,
        subjectFieldText: '',
        keywordsFieldText: '',
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (28,9): Type 'null' is not assignable to type 'OwaDate'.
        // @ts-expect-error
        fromDate: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (32,9): Type 'null' is not assignable to type 'OwaDate'.
        // @ts-expect-error
        toDate: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (36,9): Type 'null' is not assignable to type 'boolean'.
        // @ts-expect-error
        hasAttachments: null,
        fromPeopleSuggestions: [],
        toPeopleSuggestions: [],
        ccPeopleSuggestions: [],
    };
}
